import React from 'react';
import Highcharts from 'highcharts';

import { ChartContent } from '../../Chart';

const ScatterView = ({
  chartRef,
  options,
  isNoData,
  useSmallNoDataMessage,
}: {
  chartRef: React.MutableRefObject<any>;
  options: Highcharts.Options;
  isNoData: boolean;
  useSmallNoDataMessage: boolean;
}) => {
  return (
    <ChartContent
      chartRef={chartRef}
      options={options}
      noDataToDisplay={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default ScatterView;
